var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 8V64H8V8H64ZM68.4 0H3.6C1.6 0 0 1.6 0 3.6V68.4C0 70 1.6 72 3.6 72H68.4C70 72 72 70 72 68.4V3.6C72 1.6 70 0 68.4 0ZM32 16H56V24H32V16ZM32 32H56V40H32V32ZM32 48H56V56H32V48ZM16 16H24V24H16V16ZM16 32H24V40H16V32ZM16 48H24V56H16V48Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.5980b8cd1e0ef22c664b99930d552be3.svg";
export { ForwardRef as ReactComponent };